export default __webpack_public_path__ + "basketball-live.png";